import {Alert, Button, Layout} from 'antd';
import {useEffect, useRef} from 'react';
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import SignIn from '../modules/SignIn';
import {reducersState} from '../redux/reducers';
import {SiderComponent} from '../components/Sider';

import {Content} from 'antd/lib/layout/layout';
import 'react-toastify/dist/ReactToastify.css';
import {ClassHomePage} from '../pages/classPage';
import {StudentReportPage} from '../pages/studentPage';
import {doSignInWithPartner, isLoadingRequest} from '../redux/actions/user';
import StudentsArrangementPage from '../pages/StudentsArrangementPage';
import {AdminPage} from '../modules/Admin';
import {SchoolHomePage} from '../pages/schoolPage';

export const Routers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const isLoggedIn = useSelector((s: reducersState) => s.user.isLoggedIn);
  const school = useSelector((s: reducersState) => s.user.school);
  const teacher = useSelector((s: reducersState) => s.user.teacher);
  const isPartner = useSelector((s: any) => s.user.partnerUser);
  const error = useSelector((s: reducersState) => s.user.error);

  // Track whether we've already done the initial post-login redirect
  const hasRedirectedAfterLogin = useRef(false);

  // Partner login flow using URLSearchParams (expects URLs like ?partner=123&token=abc)
  useEffect(() => {
    if (
      location?.search &&
      location?.search?.includes('partner') &&
      location?.search?.includes('token') &&
      !isPartner
    ) {
      const params = new URLSearchParams(location.search);
      const partnerId = params.get('partner');
      if (partnerId) {
        // @ts-ignore: Suppressing type error for partnerData as any
        const partnerData: any = {id: partnerId};
        // @ts-ignore: Suppressing type error for doSignInWithPartner parameters
        dispatch(doSignInWithPartner({url: location.search}, partnerData));
      }
    }
  }, [dispatch, isPartner, location.search]);

  // Reset redirect flag when user logs out
  useEffect(() => {
    if (!isLoggedIn && !isPartner) {
      hasRedirectedAfterLogin.current = false;
    }
  }, [isLoggedIn, isPartner]);

  // Redirect to home page after sign in (only once per login session)
  useEffect(() => {
    if ((isLoggedIn || isPartner) && school && !hasRedirectedAfterLogin.current) {
      hasRedirectedAfterLogin.current = true;
      navigate(`/school/${school.id}`, { replace: true });
    }
  }, [isLoggedIn, isPartner, school, navigate]);

  return (
    <div>
      {error && (
        <div style={{position: 'absolute', top: 50, zIndex: 5}}>
          <Alert
            message="Error Occurs"
            description={error.message}
            type="error"
            showIcon
            action={
              <Button
                size="small"
                danger
                onClick={() => dispatch(isLoadingRequest(false, null))}>
                Dismiss
              </Button>
            }
          />
        </div>
      )}
      {!isLoggedIn ? (
        <SignIn />
      ) : (
        <Layout>
          <Content style={{backgroundColor: '#fff'}}>
            <SiderComponent />
            <Routes>
              <Route
                path="student/:studentId"
                element={
                  // If StudentReportPage requires a "student" prop,
                  // consider refactoring so it uses useParams() internally.
                  // For now, we pass a dummy value to satisfy the type checker.
                  <StudentReportPage student={null as any} />
                }
              />
              <Route
                path="students-arrangement"
                element={<StudentsArrangementPage />}
              />
              <Route path="schools" element={<AdminPage />} />
              <Route path="school/:schoolId/detailed" element={<ClassHomePage />} />
              <Route
                path="school/:schoolId"
                element={teacher ? <ClassHomePage /> : <SchoolHomePage />} //TODO: setup teacher status
              />
              {/* Catch-all route to redirect unknown paths */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Content>
        </Layout>
      )}
    </div>
  );
};
